import React, { useState, useContext } from 'react';
import { useDispatch } from 'react-redux';
import { ReportUsageContext } from 'src/pages/reportUsage';
import { useTranslation } from 'react-i18next';
import { Box } from '@material-ui/core';
import {
    ParentDiv,
    StyledDiv,
    DesktopDiv,
    Heading1,
    Heading2,
    ImgIcon,
    ImgCont,
    ErrorMsgContainer,
    WhyNotImplantedDiv,
    DisplayDiv,
    ImplantedAsMainRodDiv,
    BottomCardDiv,
} from './UnidSurgeryInfo.styled';
import PatientInformation from 'src/pages/reportUsage/common/patientInformation/PatientInformation';
import { Title } from '../Procedure.styled';
import {
    NoDataText,
    TitleComponent,
} from 'src/pages/reportUsage/utils/reportUsage.styled';
import Checkbox from 'src/common/refactoredComponents/checkbox/Checkbox';
import {
    InfoItemsValue,
    InfoMainContainer,
} from 'src/pages/reportUsage/common/patientInformation/PatientInformation.styled';
import RadioButton from 'src/common/refactoredComponents/RadioButton/RadioButton';
import Notes from 'src/common/components/notes';
import { sizes } from 'src/styles/Media.styled';
import InfoIcon from 'src/assets/images/InfoIcon.svg';
import NotImplantingUNiDRods from './NotImplantingUNiDRods';
import NotImplantingAllUNiDRods from './NotImplantingAllUNiDRods';
import {
    getModifiedButtonVisibilities,
    generateUnidInfoRequestObject,
} from 'src/pages/reportUsage/utils/eventHandlerUtil';
import CancelAlertPopup from 'src/pages/reportUsage/common/cancelAlertPopup';
import {
    isUnidSurgeryFooterBtnEnabled,
    getExistingUnidProducts,
    getItemsCheckedObj,
} from '../../dataTransformationUtil';
import {
    getDraftWhyAllRodsNotImplanted,
    getDraftMainRodCount,
} from 'src/pages/reportUsage/utils/dataModificaionUtil';
import { hideScrolling, resumeScrolling, isIpad, logErrorToConsole } from 'src/utils/util';
import { useDynatracePageName } from 'src/common/hooks/useDynatracePageName';
import { pageNames } from 'src/constants/appConstants';
import WarningModal from 'src/pages/reportUsage/common/warningModal';
import MpxrConfirmationCard from './mPXRConfirmationCard';
import AlertMsg from 'src/pages/reportUsage/common/AlertMsg';
import { STORE_UNID_SURGERY_INFO } from 'src/pages/reportUsage/redux/action/types';
import { setReportUsageFormObject } from 'src/pages/reportUsage/redux/action/actionCreators';
import { DARK_NAVY_FONT_COLOR, FONT_FAMILY_DEMI, SEMANTIC_TEXT_PX } from 'src/styles/fonts/MCFontConstants';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const UnidSurgeryInfo = ({
    itemTableData,
    navigateToSpecifiedScreen,
    unidSurgeryInfo,
    setUnidSurgeryInfo,
    storedUnidSurgeryData,
    alertPopup,
    setAlertPopup,
    myCaseResourceType,
}) => {
    const {
        usageDetails,
        reportUsageFormObj,
        setReportUsageFormObj,
        footerButtonStatuses,
        setFooterButtonStatuses,
    } = useContext(ReportUsageContext);
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [fewItemsChecked, setFewItemChecked] = useState(false);
    const [allUnidItemschecked, setAllUnidItemsChecked] = useState(false);
    const [noneChecked, setNoneChecked] = useState(false);
    const charCountLimit = 250;
    const [textAreaCharLimit] = useState(charCountLimit);
    const [search, setSearch] = useState(false);
    const [allSearch, setAllSearch] = useState(false);
    const [showReasonInDetail, setShowReasonInDetail] = useState(false);
    const [isValid, setIsValid] = useState(false);
    const [showMpxr, setShowMpxr] = useState(false);
    const [isConfirmationCheckboxChecked, setIsConfirmationCheckboxChecked] =
        useState(
            storedUnidSurgeryData?.mPXR ? storedUnidSurgeryData?.mPXR : false
        );

    const [showConfirmationCheckbox, setShowConfirmationCheckbox] = useState(
        storedUnidSurgeryData?.mPXR ? storedUnidSurgeryData?.mPXR : false
    );

    const whyAllRodsNotImplanted = [
        {
            id: 1,
            label: t('procedure.unid.SurgeonChangedSurgicalPlan'),
            isChecked: false,
        },
        {
            id: 2,
            label: t('procedure.unid.IssuewithLengthorContour'),
            isChecked: false,
        },
        {
            id: 3,
            label: t('procedure.unid.SalesOperations'),
            isChecked: false,
        },
        {
            id: 4,
            label: t('procedure.unid.ManufacturingIssue'),
            isChecked: false,
        },
        {
            id: 5,
            label: t('procedure.unid.NotDeliveredonTime'),
            isChecked: false,
        },
        {
            id: 6,
            label: t('procedure.unid.MultipleVersionsOrdered'),
            isChecked: false,
        },
    ];

    useDynatracePageName(pageNames.reportUsageUnidSurgeryInfo);

    useEffectWithErrorLogging(() => {
        if (showMpxr || search.showPopup) {
            hideScrolling();
        } else {
            resumeScrolling();
        }
    }, [showMpxr, search]);

    useEffectWithErrorLogging(() => {
        let body = document.getElementById('body');
        if (allSearch) {
            body.style.overflow = 'hidden';
        } else {
            body.style.overflow = '';
        }
    }, [allSearch]);
    //DraftNotSubmit & createUsage
    useEffectWithErrorLogging(() => {
        if (
            usageDetails &&
            usageDetails.unidSurgeryInfoPage &&
            Object.keys(usageDetails.unidSurgeryInfoPage).length > 0
        ) {
            const draftUnidSurgeryInfo = {
                unidProducts: getExistingUnidProducts(
                    usageDetails.unidSurgeryInfoPage?.deliveredRodItems,
                    itemTableData,
                    usageDetails.unidSurgeryInfoPage?.unidImplanteditems
                ),
                whyAllRodsNotImplanted: getDraftWhyAllRodsNotImplanted(
                    whyAllRodsNotImplanted,
                    usageDetails.unidSurgeryInfoPage
                ),
                reasonText: usageDetails.unidSurgeryInfoPage
                    .manufacturingIssueText
                    ? usageDetails.unidSurgeryInfoPage.manufacturingIssueText
                    : usageDetails.unidSurgeryInfoPage.salesOperationsText,

                mPXR:
                    usageDetails.unidSurgeryInfoPage?.unidImplanteditems &&
                    usageDetails.unidSurgeryInfoPage?.unidImplanteditems
                        .length > 0
                        ? usageDetails.unidSurgeryInfoPage.mpxr
                            ? (setShowConfirmationCheckbox(true),
                              setIsConfirmationCheckboxChecked(true),
                              usageDetails.unidSurgeryInfoPage.mpxr)
                            : (!getDraftMainRodCount(
                                  usageDetails.unidSurgeryInfoPage
                              ) > 0 &&
                                  usageDetails.unidSurgeryInfoPage?.unidImplanteditems.some(
                                      (product) => {
                                          return product.isRodIssueWithLengthOrContour;
                                      }
                                  ) &&
                                  setShowConfirmationCheckbox(true),
                              isConfirmationCheckboxChecked)
                        : isConfirmationCheckboxChecked,
                mainRodCount: getDraftMainRodCount(
                    usageDetails.unidSurgeryInfoPage
                ),
            };
            const noneItemChecked = draftUnidSurgeryInfo.unidProducts.find(
                (item) => item.productCFN === 'None' && item.isChecked
            );
            setNoneChecked(noneItemChecked ? true : false);
            setAllUnidItemsChecked(
                getItemsCheckedObj(draftUnidSurgeryInfo.unidProducts)
                    .allItemsChecked
                    ? true
                    : false
            );
            setFewItemChecked(
                getItemsCheckedObj(draftUnidSurgeryInfo.unidProducts)
                    .fewItemsChecked
                    ? true
                    : false
            );
            setUnidSurgeryInfo(draftUnidSurgeryInfo);
            dispatch({
                type: STORE_UNID_SURGERY_INFO,
                payload: draftUnidSurgeryInfo,
            });
        } else {
            setUnidSurgeryInfo({
                unidProducts: [
                    {
                        description: '',
                        productCFN: 'None',
                        isChecked: true,
                    },
                ],
                whyAllRodsNotImplanted,
                reasonText: '',
                mPXR: isConfirmationCheckboxChecked,
                mainRodCount: 0,
            });
            dispatch({
                type: STORE_UNID_SURGERY_INFO,
                payload: {
                    unidProducts: [
                        {
                            description: '',
                            productCFN: 'None',
                            isChecked: true,
                        },
                    ],
                    whyAllRodsNotImplanted,
                    reasonText: '',
                    mPXR: isConfirmationCheckboxChecked,
                    mainRodCount: 0,
                },
            });
            setNoneChecked(true);
            setAllUnidItemsChecked(false);
            setFewItemChecked(false);
        }
    }, [usageDetails, itemTableData]);

    //data retain
    useEffectWithErrorLogging(() => {
        if (
            storedUnidSurgeryData &&
            Object.keys(storedUnidSurgeryData).length > 0 &&
            storedUnidSurgeryData?.unidProducts
        ) {
            const unidSurgeryData = {
                ...storedUnidSurgeryData,
                unidProducts: storedUnidSurgeryData?.unidProducts?.map(
                    (unidItem) => ({
                        ...unidItem,
                        isChecked: unidItem.isChecked,
                    })
                ),
            };
            unidSurgeryData.unidProducts = unidSurgeryData?.unidProducts?.map(
                (unidItem) => {
                    let item = {
                        ...unidItem,
                    };
                    if (unidItem.productCFN === 'None') return item;
                    let isChecked = false;
                    itemTableData.map((item) => {
                        if (
                            !isChecked &&
                            item.isBundleItem &&
                            item.children &&
                            item.children.length > 0
                        ) {
                            isChecked = item.children
                                .map((childItem) => childItem.cfn)
                                .includes(unidItem.productCFN);

                            item.isChecked = isChecked;
                        }
                    });
                    return item;
                }
            );
            if (
                unidSurgeryData.unidProducts &&
                unidSurgeryData.unidProducts.filter(
                    (x) => x.productCFN !== 'None'
                )?.length > 0 &&
                !unidSurgeryData.unidProducts.filter(
                    (x) => x.productCFN !== 'None'
                )
            ) {
                const noneIdx = unidSurgeryData.unidProducts.findIndex(
                    (x) => x.productCFN === 'None'
                );
                unidSurgeryData.unidProducts[noneIdx].isChecked = true;
                unidSurgeryData.reasonText = '';
                // unidSurgeryData.mPXR = unidSurgeryData.mPXR;
                unidSurgeryData.mainRodCount = 0;
            }
            setUnidSurgeryInfo(unidSurgeryData);
            // dispatch({
            //     type: STORE_UNID_SURGERY_INFO,
            //     payload: unidSurgeryData,
            // });
            if (
                unidSurgeryData.unidProducts &&
                getItemsCheckedObj(unidSurgeryData.unidProducts).allItemsChecked
            ) {
                setFewItemChecked(false);
                setAllUnidItemsChecked(true);
                setNoneChecked(false);
            } else if (
                unidSurgeryData.unidProducts &&
                getItemsCheckedObj(unidSurgeryData.unidProducts).fewItemsChecked
            ) {
                setFewItemChecked(true);
                setAllUnidItemsChecked(false);
                setNoneChecked(false);
            } else if (
                unidSurgeryData.unidProducts &&
                unidSurgeryData.unidProducts.find(
                    (x) => x.productCFN === 'None'
                ).isChecked
            ) {
                setNoneChecked(true);
                setAllUnidItemsChecked(false);
                setFewItemChecked(false);
            } else {
                setNoneChecked(false);
                setAllUnidItemsChecked(false);
                setFewItemChecked(false);
            }
            const isSalesOperationsChecked =
                unidSurgeryData.whyAllRodsNotImplanted?.find(
                    (item) => item.id === 3 && item.isChecked
                );
            const isManufacturingIssueChecked =
                unidSurgeryData.whyAllRodsNotImplanted?.find(
                    (item) => item.id === 4 && item.isChecked
                );
            setShowReasonInDetail(
                isSalesOperationsChecked || isManufacturingIssueChecked
                    ? true
                    : false
            );
            showMPXRConfirmationCard();
            setIsConfirmationCheckboxChecked(unidSurgeryData.mPXR);
        }
    }, [storedUnidSurgeryData]);

    //Footer Buttons
    useEffectWithErrorLogging(() => {
        if (
            unidSurgeryInfo.unidProducts &&
            unidSurgeryInfo.unidProducts.length > 0
        ) {
            let modifiedButtonStatuses = [...footerButtonStatuses];
            if (
                unidSurgeryInfo.unidProducts.some(
                    (product) => product.isChecked
                )
            ) {
                modifiedButtonStatuses = getModifiedButtonVisibilities(
                    myCaseResourceType,
                    footerButtonStatuses,
                    unidSurgeryInfo.whyAllRodsNotImplanted.some(
                        (item) =>
                            item.isChecked && item.id !== 1 && item.id !== 2
                    )
                        ? t(
                              'reportUsage.reportUsageFooterbuttons.orReportButton'
                          )
                        : t(
                              'reportUsage.reportUsageFooterbuttons.reviewButton'
                          ),

                    unidSurgeryInfo.whyAllRodsNotImplanted.some(
                        (item) =>
                            item.isChecked && item.id !== 1 && item.id !== 2
                    )
                        ? t('reportUsage.reportUsageFooterbuttons.reviewButton')
                        : t(
                              'reportUsage.reportUsageFooterbuttons.orReportButton'
                          )
                );
            }
            // Ensure UNiD Info button is hidden since we are on the UNiD Info screen
            const unidInfoIdx = modifiedButtonStatuses.findIndex(
                (x) => x.btnName === t('reportUsage.progressBar.UNiDInfo')
            );
            if (unidInfoIdx >= 0) {
                modifiedButtonStatuses[unidInfoIdx] = {
                    ...modifiedButtonStatuses[unidInfoIdx],
                    btnVisibility: false,
                };
            }
            setFooterButtonStatuses(
                modifiedButtonStatuses.map((x) =>
                    x.btnName !==
                        t(
                            'reportUsage.reportUsageFooterbuttons.cancelButton'
                        ) &&
                    x.btnName !== t('equity.equityFooter.saveAndExitButton') &&
                    x.btnVisibility
                        ? {
                              ...x,
                              isBtnDisable:
                                  !isUnidSurgeryFooterBtnEnabled(
                                      unidSurgeryInfo
                                  ),
                          }
                        : x
                )
            );
            showMPXRConfirmationCard();
            setIsValid(isUnidSurgeryFooterBtnEnabled(unidSurgeryInfo));

            const unidInfoRequestObject =
                generateUnidInfoRequestObject(unidSurgeryInfo);
            if (
                unidInfoRequestObject &&
                Object.keys(unidInfoRequestObject).length > 0
            ) {
                setReportUsageFormObj({
                    ...reportUsageFormObj,
                    unidSurgeryInfoPage: unidInfoRequestObject,
                    ispjkOrder:
                        usageDetails?.ispjkOrder !== '' &&
                        usageDetails.ispjkOrder,
                });
            }
        }
    }, [unidSurgeryInfo]);

    useEffectWithErrorLogging(() => {
        dispatch(setReportUsageFormObject(reportUsageFormObj));
    }, [reportUsageFormObj]);

    useEffectWithErrorLogging(() => {
        setUnidSurgeryInfo((prevState) => ({
            ...prevState,
            mPXR: isConfirmationCheckboxChecked,
        }));
        dispatch({
            type: STORE_UNID_SURGERY_INFO,
            payload: {
                ...unidSurgeryInfo,
                mPXR: isConfirmationCheckboxChecked,
            },
        });
    }, [isConfirmationCheckboxChecked]);

    useEffectWithErrorLogging(() => {
        if (Object.keys(alertPopup).length > 0 && alertPopup.show) {
            hideScrolling();
        } else {
            resumeScrolling();
        }
    }, [alertPopup]);

    const updateReason = (ReasonInDetail) => {
        if (ReasonInDetail.length > charCountLimit) {
            const sliceLastIdx = charCountLimit - ReasonInDetail.length;
            ReasonInDetail = ReasonInDetail.slice(0, sliceLastIdx);
        }
        setUnidSurgeryInfo({ ...unidSurgeryInfo, reasonText: ReasonInDetail });
        dispatch({
            type: STORE_UNID_SURGERY_INFO,
            payload: { ...unidSurgeryInfo, reasonText: ReasonInDetail },
        });
    };

    const showMPXRConfirmationCard = () => {
        const modifiedUnidProducts = [...unidSurgeryInfo.unidProducts];

        let reasonProvided = modifiedUnidProducts.some((data) => {
            if (data.productCFN == 'None') {
                return unidSurgeryInfo.whyAllRodsNotImplanted.some(
                    (product) => {
                        return (
                            (product.label ==
                                t('procedure.unid.IssuewithLengthorContour') &&
                                product.isChecked) ||
                            (product.label ==
                                t('procedure.unid.ManufacturingIssue') &&
                                product.isChecked)
                        );
                    }
                );
            } else {
                return (
                    data.productCFN !== 'None' &&
                    (data.whyNotImplantedAsMainRod.some((product) => {
                        return (
                            product.label ==
                                t('procedure.unid.IssuewithLengthorContour') &&
                            product.isChecked
                        );
                    }) ||
                        (data.implantedAsMainRod == 'No' &&
                            unidSurgeryInfo.whyAllRodsNotImplanted.some(
                                (product) => {
                                    return (
                                        (product.label ==
                                            t(
                                                'procedure.unid.IssuewithLengthorContour'
                                            ) &&
                                            product.isChecked) ||
                                        (product.label ==
                                            t(
                                                'procedure.unid.ManufacturingIssue'
                                            ) &&
                                            product.isChecked)
                                    );
                                }
                            )))
                );
            }
        });
        if (reasonProvided) {
            setShowConfirmationCheckbox(true);
        } else {
            setShowConfirmationCheckbox(false),
                setIsConfirmationCheckboxChecked(false);
        }
    };

    const getModifiedData = (
        idx,
        type,
        label,
        productCFN,
        unidCounter,
        unidLineNumber,
        parentLineNumber
    ) => {
        if (type === 'few') {
            const modifiedUnidProductss = [...unidSurgeryInfo.unidProducts];
            modifiedUnidProductss.map((data) => {
                if (
                    data.productCFN === productCFN &&
                    data.unidCounter === unidCounter &&
                    data.unidLineNumber === unidLineNumber &&
                    data.parentLineNumber === parentLineNumber
                ) {
                    data.whyNotImplantedAsMainRod.map((product, index) => {
                        product.isChecked = idx === index;
                    });
                }
            });

            showMPXRConfirmationCard();

            setUnidSurgeryInfo((prevState) => ({
                ...prevState,
                unidProducts: modifiedUnidProductss,
            }));
            dispatch({
                type: STORE_UNID_SURGERY_INFO,
                payload: {
                    ...unidSurgeryInfo,
                    unidProducts: modifiedUnidProductss,
                },
            });

            label === t('procedure.unid.IssuewithLengthorContour')
                ? setShowMpxr(true)
                : setShowMpxr(false);
        }
        if (type === 'all') {
            const modifiedData = unidSurgeryInfo.whyAllRodsNotImplanted.map(
                (data, index) => ({
                    ...data,
                    isChecked: idx === index,
                })
            );
            showMPXRConfirmationCard();

            setUnidSurgeryInfo((prevState) => ({
                ...prevState,
                whyAllRodsNotImplanted: modifiedData,
                reasonText: '',
            }));
            dispatch({
                type: STORE_UNID_SURGERY_INFO,
                payload: {
                    ...unidSurgeryInfo,
                    whyAllRodsNotImplanted: modifiedData,
                    reasonText: '',
                },
            });
            const isSalesOperationsChecked = modifiedData.find(
                (item) => item.id === 3 && item.isChecked
            );
            const isManufacturingIssueChecked = modifiedData.find(
                (item) => item.id === 4 && item.isChecked
            );
            setShowReasonInDetail(
                isSalesOperationsChecked || isManufacturingIssueChecked
            );

            label === t('procedure.unid.IssuewithLengthorContour') ||
            label === t('procedure.unid.ManufacturingIssue')
                ? setShowMpxr(true)
                : setShowMpxr(false);
        }
    };

    const itemCheckboxChangeHandler = (
        productCFN,
        unidCounter,
        unidLineNumber,
        parentLineNumber
    ) => {
        let modifiedUnidProducts = [...unidSurgeryInfo.unidProducts];
        const noneIdx = modifiedUnidProducts.findIndex(
            (x) => x.productCFN === 'None'
        );

        // Removing the Deleted Item Popup Functionality as per SIM-533.
        // if (
        //     productCFN !== 'None' &&
        //     !itemTableData.find((item) => item.cfn === productCFN) &&
        //     !modifiedUnidProducts.find((item) => item.productCFN === productCFN)
        //         .isChecked
        // ) {
        //     // setAlertPopup({ show: true, product: productCFN });
        // } else {
        // setAlertPopup({ show: false });
        // }
        if (productCFN === 'None' && noneIdx >= 0) {
            modifiedUnidProducts[noneIdx].isChecked =
                !modifiedUnidProducts[noneIdx].isChecked;

            if (modifiedUnidProducts[noneIdx].isChecked) {
                modifiedUnidProducts = modifiedUnidProducts.map((data) => ({
                    ...data,
                    isChecked:
                        data.productCFN === 'None' &&
                        modifiedUnidProducts[noneIdx].isChecked
                            ? true
                            : false,
                }));
            }

            modifiedUnidProducts.map((data) => {
                data.productCFN !== 'None' &&
                    data.whyNotImplantedAsMainRod.map(
                        (item) => (item.isChecked = false)
                    );
                data.implantedAsMainRod = null;
            });

            setIsConfirmationCheckboxChecked(false);
        } else {
            modifiedUnidProducts = modifiedUnidProducts.map((data) => ({
                ...data,
                isChecked:
                    data.productCFN === productCFN &&
                    data.unidCounter === unidCounter &&
                    data.unidLineNumber === unidLineNumber &&
                    data.parentLineNumber === parentLineNumber
                        ? !data.isChecked
                        : data.productCFN === 'None'
                        ? false
                        : data.isChecked,
                implantedAsMainRod:
                    data.productCFN === productCFN &&
                    data.unidCounter === unidCounter &&
                    data.unidLineNumber === unidLineNumber &&
                    data.parentLineNumber === parentLineNumber
                        ? null
                        : data.implantedAsMainRod,
                whyNotImplantedAsMainRod:
                    data.productCFN === productCFN &&
                    data.unidCounter === unidCounter &&
                    data.unidLineNumber === unidLineNumber &&
                    data.parentLineNumber === parentLineNumber
                        ? !data.isChecked
                            ? data.whyNotImplantedAsMainRod
                            : data.whyNotImplantedAsMainRod.map((product) => ({
                                  ...product,
                                  isChecked: false,
                              }))
                        : data.whyNotImplantedAsMainRod,
            }));
        }
        setShowReasonInDetail(false);

        let existingMainRodCount = modifiedUnidProducts.filter(
            (data) => data.implantedAsMainRod == 'Yes'
        ).length;

        let modifiedWhyAllRodsNotImplanted = [
            ...unidSurgeryInfo.whyAllRodsNotImplanted,
        ];

        let ExceptNoneAllitems = modifiedUnidProducts.filter(
            (product) => product.productCFN !== 'None'
        );

        let ExceptNoneAllitemsSelected =
            ExceptNoneAllitems &&
            ExceptNoneAllitems.length > 0 &&
            ExceptNoneAllitems.every((data) => {
                return data.isChecked;
            });

        if (ExceptNoneAllitemsSelected) {
            modifiedWhyAllRodsNotImplanted.map((data) => {
                data.isChecked = false;
            });
        }

        setUnidSurgeryInfo({
            unidProducts: modifiedUnidProducts,
            reasonText: '',
            mainRodCount: existingMainRodCount,
            mPXR: isConfirmationCheckboxChecked,
            whyAllRodsNotImplanted: modifiedWhyAllRodsNotImplanted,
        });
        dispatch({
            type: STORE_UNID_SURGERY_INFO,
            payload: {
                unidProducts: modifiedUnidProducts,
                reasonText: '',
                mainRodCount: existingMainRodCount,
                mPXR: isConfirmationCheckboxChecked,
                whyAllRodsNotImplanted: modifiedWhyAllRodsNotImplanted,
            },
        });

        showMPXRConfirmationCard();
        const checkedItems = modifiedUnidProducts.filter(
            (item) => item.isChecked && item.productCFN !== 'None'
        );
        if (checkedItems.length > 0) {
            if (checkedItems.length === modifiedUnidProducts.length - 1) {
                setAllUnidItemsChecked(true);
                setFewItemChecked(false);
            } else {
                setFewItemChecked(true);
                setAllUnidItemsChecked(false);
            }
            setNoneChecked(false);
        } else if (
            checkedItems.length === 0 &&
            modifiedUnidProducts[noneIdx].isChecked
        ) {
            setNoneChecked(true);
            setAllUnidItemsChecked(false);
            setFewItemChecked(false);
        } else {
            setNoneChecked(false);
            setAllUnidItemsChecked(false);
            setFewItemChecked(false);
        }
    };

    const returnToUsageScreenClickHandler = () => {
        setAlertPopup({ show: false });
        navigateToSpecifiedScreen('Record');
    };

    const continueWithoutAddingUsageHandler = () => {
        const deletedItemIdx = unidSurgeryInfo.unidProducts.findIndex(
            (x) => x.productCFN === alertPopup.product
        );
        if (deletedItemIdx >= 0) {
            const modifiedUnidProducts = [...unidSurgeryInfo.unidProducts];
            modifiedUnidProducts[deletedItemIdx].isChecked =
                !modifiedUnidProducts[deletedItemIdx].isChecked;
            modifiedUnidProducts[deletedItemIdx].isDeletedItemChecked =
                modifiedUnidProducts[deletedItemIdx].isChecked;
            if (modifiedUnidProducts[deletedItemIdx].isChecked) {
                const noneIdx = modifiedUnidProducts.findIndex(
                    (x) => x.productCFN === 'None'
                );
                modifiedUnidProducts[noneIdx].isChecked = false;
                setNoneChecked(false);
                if (getItemsCheckedObj(modifiedUnidProducts).allItemsChecked) {
                    setAllUnidItemsChecked(true);
                    setFewItemChecked(false);
                } else if (
                    getItemsCheckedObj(modifiedUnidProducts).fewItemsChecked
                ) {
                    setAllUnidItemsChecked(false);
                    setFewItemChecked(true);
                } else {
                    setAllUnidItemsChecked(false);
                    setFewItemChecked(false);
                }
            }
            setShowReasonInDetail(false);
            setUnidSurgeryInfo({
                ...unidSurgeryInfo,
                whyAllRodsNotImplanted,
                reasonText: '',
                unidProducts: modifiedUnidProducts,
            });
            dispatch({
                type: STORE_UNID_SURGERY_INFO,
                payload: {
                    ...unidSurgeryInfo,
                    whyAllRodsNotImplanted,
                    reasonText: '',
                    unidProducts: modifiedUnidProducts,
                },
            });
        }
        setAlertPopup({ show: false });
    };

    const implantedAsMainRodRadioBtnChangeHandler = (
        productCFN,
        unidCounter,
        unidLineNumber,
        parentLineNumber,
        selectedRadioVal
    ) => {
        unidSurgeryInfo?.unidProducts.map((data) => {
            if (
                data.productCFN === productCFN &&
                data.unidCounter === unidCounter &&
                data.unidLineNumber === unidLineNumber &&
                data.parentLineNumber === parentLineNumber
            ) {
                data.implantedAsMainRod = selectedRadioVal;
            }
        });

        let mainRodCount = unidSurgeryInfo?.unidProducts.filter(
            (data) => data.implantedAsMainRod == 'Yes'
        ).length;

        if (mainRodCount == 2) {
            unidSurgeryInfo?.unidProducts.map((item) => {
                if (
                    item.productCFN !== 'None' &&
                    item.isChecked &&
                    item.implantedAsMainRod !== 'Yes'
                ) {
                    item.implantedAsMainRod = null;
                }
            });
        } else if (mainRodCount > 0) {
            unidSurgeryInfo?.unidProducts.map((items) => {
                items.productCFN !== 'None' &&
                    items.whyNotImplantedAsMainRod.map((item) => {
                        item.isChecked = false;
                    });
            });
        }

        showMPXRConfirmationCard();

        setUnidSurgeryInfo({
            ...unidSurgeryInfo,
            reasonText: '',
            mainRodCount: unidSurgeryInfo?.unidProducts.filter(
                (data) => data.implantedAsMainRod == 'Yes'
            ).length,
        });
        dispatch({
            type: STORE_UNID_SURGERY_INFO,
            payload: {
                ...unidSurgeryInfo,
                reasonText: '',
                mainRodCount: unidSurgeryInfo?.unidProducts.filter(
                    (data) => data.implantedAsMainRod == 'Yes'
                ).length,
            },
        });
        setShowReasonInDetail(false);
    };

    return (
        <ParentDiv>
            <TitleComponent>
                {t(
                    'reportUsage.procedure.unidSurgery.UnidSurgeryInfo.titleComponent'
                )}
            </TitleComponent>
            <PatientInformation />

            <Box
                my={1}
                bgcolor={'#ffffff'}
                borderRadius={5}
                padding={
                    window.innerWidth <= sizes.mobileDevice
                        ? '20px 18px'
                        : '20px 22px 20px 22px'
                }
                width={'99.66%'}
                marginBottom={'24px'}
                border={isValid ? '1px solid #12C8F7' : ''}
                marginLeft={'1px'}
                marginRight={'1px'}
            >
                <Title fontSize={'16px'} color={'#140f4b'}>
                    <span>
                        {t(
                            'reportUsage.procedure.unidSurgery.UnidSurgeryInfo.unidRodUse'
                        )}
                    </span>
                    <span className="asterisk">*</span>
                </Title>
                <NoDataText
                    fontSize="12px"
                    color="#202124"
                    padding="0 0 20px 0"
                >
                    {t('reportUsage.procedure.unidSurgery.UnidSurgeryInfo.msg')}
                </NoDataText>

                <InfoMainContainer justifyContent={'flex-start'}>
                    {unidSurgeryInfo.unidProducts?.length > 0 &&
                        unidSurgeryInfo.unidProducts.map((data, index) => (
                            <DesktopDiv isIpad={isIpad()} key={index}>
                                <div
                                    style={{
                                        margin:
                                            window.innerWidth <=
                                            sizes.mobileDevice
                                                ? '5px 0px'
                                                : '5px',

                                        background: '#F5F5F5',
                                        borderRadius: '6px',
                                        padding: '10px',
                                    }}
                                >
                                    <Checkbox
                                        id={data.id}
                                        label={data.productCFN}
                                        checked={data.isChecked}
                                        onCheckboxSelectionChange={() =>
                                            itemCheckboxChangeHandler(
                                                data.productCFN,
                                                data.unidCounter,
                                                data.unidLineNumber,
                                                data.parentLineNumber
                                            )
                                        }
                                        margin={'0px 6px 0px 0px'}
                                        labelStyleObj={{
                                            fontSize: SEMANTIC_TEXT_PX,
                                            fontFamily: FONT_FAMILY_DEMI,
                                            color: DARK_NAVY_FONT_COLOR,
                                            padding: '0 0 0 10px',
                                        }}
                                        background={'none'}
                                        checkboxBorder={'1.5px solid #555555'}
                                        alignItemDirection={'center'}
                                        hoverEffect={'false'}
                                        disableFocusEffect={'true'}
                                    />

                                    <InfoItemsValue
                                        fontSize={'12px'}
                                        padding={'0 0 0 36px'}
                                        marginBottom={'0px'}
                                    >
                                        {data.productCFN !== 'None' &&
                                            ` ${t(
                                                'consignmentBilling.payment.reportPayment.qTY'
                                            )}:  ${data.uniqQty}
                                            ${
                                                data.rodEtching !== undefined
                                                    ? `- Etch: ${data.rodEtching}`
                                                    : ''
                                            }`}
                                    </InfoItemsValue>
                                    <InfoItemsValue
                                        fontSize={'12px'}
                                        padding={'0 0 0 36px'}
                                        marginBottom={'0px'}
                                    >
                                        {data.description}
                                    </InfoItemsValue>

                                    {
                                        // (allUnidItemschecked || fewItemsChecked) &&
                                        (unidSurgeryInfo.mainRodCount == 0 ||
                                            unidSurgeryInfo.mainRodCount == 1 ||
                                            (unidSurgeryInfo.mainRodCount ==
                                                2 &&
                                                data.implantedAsMainRod ===
                                                    'Yes')) &&
                                            !noneChecked &&
                                            data.isChecked &&
                                            data.productCFN !== 'None' && (
                                                <>
                                                    <DesktopDiv
                                                        desktopWidth={'100%'}
                                                        style={{
                                                            paddingTop: '20px',
                                                        }}
                                                    >
                                                        <StyledDiv
                                                            display={'flex'}
                                                        >
                                                            <Title
                                                                mbpaddingBtm={
                                                                    '10px'
                                                                }
                                                                mbpaddingTop={
                                                                    '10px'
                                                                }
                                                                paddingBtm={
                                                                    '10px'
                                                                }
                                                                mbWidth={'45%'}
                                                                width={'50%'}
                                                                fontFamily={
                                                                    'AvenirNextWorld Regular'
                                                                }
                                                                fontSize={
                                                                    '16px'
                                                                }
                                                                color={
                                                                    '#140F4B'
                                                                }
                                                            >
                                                                <span>
                                                                    {t(
                                                                        'reportUsage.procedure.unidSurgery.UnidSurgeryInfo.msg2'
                                                                    )}
                                                                </span>
                                                                <span className="asterisk">
                                                                    *
                                                                </span>
                                                            </Title>
                                                            <ImplantedAsMainRodDiv>
                                                                <RadioButton
                                                                    isChecked={
                                                                        data.implantedAsMainRod ==
                                                                        'Yes'
                                                                    }
                                                                    id={'surgery-info-yes'}
                                                                    label={t(
                                                                        'reportUsage.procedure.unidSurgery.UnidSurgeryInfo.yes'
                                                                    )}
                                                                    handleChange={() =>
                                                                        implantedAsMainRodRadioBtnChangeHandler(
                                                                            data.productCFN,
                                                                            data.unidCounter,
                                                                            data.unidLineNumber,
                                                                            data.parentLineNumber,
                                                                            t(
                                                                                'reportUsage.procedure.unidSurgery.UnidSurgeryInfo.yes'
                                                                            )
                                                                        )
                                                                    }
                                                                    fontFamilyStyle="AvenirNextWorld Regular"
                                                                />
                                                                <RadioButton
                                                                    isChecked={
                                                                        data.implantedAsMainRod ==
                                                                        'No'
                                                                    }
                                                                    id={'surgery-info-no'}
                                                                    label={t(
                                                                        'reportUsage.procedure.unidSurgery.UnidSurgeryInfo.no'
                                                                    )}
                                                                    handleChange={() =>
                                                                        implantedAsMainRodRadioBtnChangeHandler(
                                                                            data.productCFN,
                                                                            data.unidCounter,
                                                                            data.unidLineNumber,
                                                                            data.parentLineNumber,
                                                                            t(
                                                                                'reportUsage.procedure.unidSurgery.UnidSurgeryInfo.no'
                                                                            )
                                                                        )
                                                                    }
                                                                    fontFamilyStyle="AvenirNextWorld Regular"
                                                                    style={{
                                                                        paddingLeft:
                                                                            '28px',
                                                                    }}
                                                                />
                                                            </ImplantedAsMainRodDiv>
                                                        </StyledDiv>
                                                    </DesktopDiv>

                                                    {
                                                        // allUnidItemschecked || fewItemsChecked) &&
                                                        // unidSurgeryInfo.implantedAsMainRod === 'No' &&
                                                        !unidSurgeryInfo.mainRodCount >
                                                            0 &&
                                                            !noneChecked &&
                                                            data.isChecked &&
                                                            data.productCFN !==
                                                                'None' &&
                                                            data.implantedAsMainRod ===
                                                                'No' && (
                                                                <>
                                                                    <DesktopDiv
                                                                        desktopWidth={
                                                                            '100%'
                                                                        }
                                                                    >
                                                                        <DisplayDiv>
                                                                            <Title
                                                                                mbpaddingBtm={
                                                                                    '10px'
                                                                                }
                                                                                mbpaddingTop={
                                                                                    '10px'
                                                                                }
                                                                                paddingBtm={
                                                                                    '10px'
                                                                                }
                                                                                paddingTop={
                                                                                    '10px'
                                                                                }
                                                                                width={
                                                                                    '100%'
                                                                                }
                                                                                fontFamily={
                                                                                    'AvenirNextWorld Demi'
                                                                                }
                                                                                fontSize={
                                                                                    '14px'
                                                                                }
                                                                                color={
                                                                                    '#202124'
                                                                                }
                                                                            >
                                                                                <Heading1>
                                                                                    {t(
                                                                                        'reportUsage.procedure.unidSurgery.UnidSurgeryInfo.header'
                                                                                    )}
                                                                                </Heading1>
                                                                                <Heading2 className="asterisk">
                                                                                    *
                                                                                </Heading2>
                                                                            </Title>
                                                                        </DisplayDiv>
                                                                        <div>
                                                                            {data.whyNotImplantedAsMainRod.map(
                                                                                (
                                                                                    item,
                                                                                    i
                                                                                ) => (
                                                                                    <>
                                                                                        <WhyNotImplantedDiv>
                                                                                            <RadioButton
                                                                                                isChecked={
                                                                                                    item.isChecked
                                                                                                }
                                                                                                id={'whynot-implant'}
                                                                                                label={
                                                                                                    item.label
                                                                                                }
                                                                                                handleChange={() =>
                                                                                                    getModifiedData(
                                                                                                        i,
                                                                                                        'few',
                                                                                                        item.label,
                                                                                                        data.productCFN,
                                                                                                        data.unidCounter,
                                                                                                        data.unidLineNumber,
                                                                                                        data.parentLineNumber
                                                                                                    )
                                                                                                }
                                                                                                fontFamilyStyle="AvenirNextWorld Regular"
                                                                                                padding={
                                                                                                    '10px 0 10px 0'
                                                                                                }
                                                                                            />

                                                                                            <ImgCont>
                                                                                                <ImgIcon
                                                                                                    src={
                                                                                                        InfoIcon
                                                                                                    }
                                                                                                    onClick={() =>
                                                                                                        setSearch(
                                                                                                            {
                                                                                                                showPopup: true,
                                                                                                                label: item.label,
                                                                                                            }
                                                                                                        )
                                                                                                    }
                                                                                                />
                                                                                            </ImgCont>
                                                                                        </WhyNotImplantedDiv>
                                                                                        {item.isChecked &&
                                                                                        item.id ==
                                                                                            2 &&
                                                                                        !isConfirmationCheckboxChecked ? (
                                                                                            <ErrorMsgContainer>
                                                                                                <AlertMsg
                                                                                                    imageMargin={
                                                                                                        '0 6px 0 0'
                                                                                                    }
                                                                                                    message={t(
                                                                                                        'procedure.unid.mPXRErrorMessage'
                                                                                                    )}
                                                                                                />
                                                                                            </ErrorMsgContainer>
                                                                                        ) : null}
                                                                                    </>
                                                                                )
                                                                            )}
                                                                        </div>
                                                                        {search?.showPopup && (
                                                                            <NotImplantingUNiDRods
                                                                                label={
                                                                                    search?.label
                                                                                }
                                                                                onClose={() =>
                                                                                    setSearch(
                                                                                        {
                                                                                            showPopup: false,
                                                                                        }
                                                                                    )
                                                                                }
                                                                            />
                                                                        )}
                                                                    </DesktopDiv>
                                                                </>
                                                            )
                                                    }
                                                </>
                                            )
                                    }
                                </div>
                            </DesktopDiv>
                        ))}
                </InfoMainContainer>

                {/* Deleted Item Popup */}

                {Object.keys(alertPopup).length > 0 && alertPopup.show && (
                    <CancelAlertPopup
                        popupTitle={t(
                            'reportUsage.procedure.unidSurgery.UnidSurgeryInfo.UNiDRodNotOnUsageForm'
                        )}
                        alertMessage={t(
                            'reportUsage.procedure.unidSurgery.UnidSurgeryInfo.attemptmsg'
                        )}
                        btn1Label={t(
                            'reportUsage.procedure.unidSurgery.UnidSurgeryInfo.continueWOUsage'
                        )}
                        btn2Label={t(
                            'reportUsage.procedure.unidSurgery.UnidSurgeryInfo.returnScreen'
                        )}
                        btn1ClickHandler={continueWithoutAddingUsageHandler}
                        btn2ClickHandler={returnToUsageScreenClickHandler}
                        btnCloseClickHandler={continueWithoutAddingUsageHandler}
                        isInUnidSurgeryInfoPage
                        margin={'6px 0 0 0'}
                        isUnidInfo={true}
                        isDelayPositionChange={true}
                    />
                )}

                {/* MPXR warning Popup */}
                {showMpxr && (
                    <>
                        <WarningModal
                            message={t('procedure.unid.mPXRErrorMessage')}
                            onClose={() => {
                                try {
                                setShowMpxr(false);
                                setShowConfirmationCheckbox(true);
                                 } catch (error) {
                                    logErrorToConsole(error);
                               }
                            }}
                            title={t('procedure.unid.ComplaintReporting')}
                            modalContentHeight={'175px'}
                            paddingLeft={'8px'}
                        />
                    </>
                )}

                {(fewItemsChecked ||
                    noneChecked ||
                    (fewItemsChecked && !allUnidItemschecked)) && (
                    <InfoMainContainer>
                        <DesktopDiv isIpad={isIpad()}>
                            <BottomCardDiv isIpad={isIpad()}>
                                <Title
                                    mbpaddingBtm={'10px'}
                                    mbpaddingTop={'10px'}
                                    paddingBtm={'10px'}
                                    paddingTop={'10px'}
                                    width={'100%'}
                                    fontFamily={'AvenirNextWorld Demi'}
                                    fontSize={'14px'}
                                    color={'#202124'}
                                >
                                    <span>
                                        {t(
                                            'reportUsage.procedure.unidSurgery.UnidSurgeryInfo.notimplement'
                                        )}
                                    </span>
                                    <span className="asterisk">*</span>
                                </Title>

                                <ImgCont>
                                    <ImgIcon
                                        src={InfoIcon}
                                        id="unid-all-info-icon"
                                        onClick={() => setAllSearch(true)}
                                    />
                                </ImgCont>
                            </BottomCardDiv>
                        </DesktopDiv>
                        <div
                            style={{
                                width:
                                    window.innerWidth <= sizes.mobileDevice
                                        ? '100%'
                                        : '67.7%',
                            }}
                        >
                            {unidSurgeryInfo.whyAllRodsNotImplanted.length >
                                0 &&
                                unidSurgeryInfo.whyAllRodsNotImplanted.map(
                                    (data, i) => (
                                        <DesktopDiv
                                            isIpad={isIpad()}
                                            desktopWidth={'50%'}
                                            desktopDisplay={'inline-table'}
                                            key={i}
                                        >
                                            <RadioButton
                                                isChecked={data.isChecked}
                                                id={'unid-all'}
                                                label={data.label}
                                                handleChange={() =>
                                                    getModifiedData(
                                                        i,
                                                        'all',
                                                        data.label,
                                                        data.productCFN,
                                                        data.unidCounter,
                                                        data.unidLineNumber,
                                                        data.parentLineNumber
                                                    )
                                                }
                                                fontFamilyStyle="AvenirNextWorld Regular"
                                                padding={'10px 0 10px 0'}
                                            />
                                            {data.isChecked &&
                                            (data.id == 2 || data.id == 4) &&
                                            !isConfirmationCheckboxChecked ? (
                                                <ErrorMsgContainer
                                                    isIpad={isIpad()}
                                                >
                                                    <AlertMsg
                                                        imageMargin={
                                                            '0 6px 0 0'
                                                        }
                                                        message={t(
                                                            'procedure.unid.mPXRErrorMessage'
                                                        )}
                                                    />
                                                </ErrorMsgContainer>
                                            ) : null}
                                        </DesktopDiv>
                                    )
                                )}

                            {allSearch && (
                                <NotImplantingAllUNiDRods
                                    onClose={() => setAllSearch(false)}
                                ></NotImplantingAllUNiDRods>
                            )}
                        </div>

                        <div
                            style={{
                                width:
                                    window.innerWidth <= sizes.mobileDevice
                                        ? '100%'
                                        : '32.2%',
                            }}
                        >
                            {showReasonInDetail && (
                                <Notes
                                    id="pricingNoteDivId"
                                    note={
                                        unidSurgeryInfo.reasonText
                                            ? unidSurgeryInfo.reasonText
                                            : ''
                                    }
                                    updateNotes={updateReason}
                                    maxLength={textAreaCharLimit}
                                    placeholder={t(
                                        'procedure.unidSurgeryInfo.unidSurgeryInfo'
                                    )}
                                    title={
                                        window.innerWidth <= sizes.mobileDevice
                                            ? t(
                                                  'procedure.unidSurgeryInfo.ReasoninDetail'
                                              )
                                            : t(
                                                  'procedure.unidSurgeryInfo.DetailedReason'
                                              )
                                    }
                                    margin={
                                        window.innerWidth <= sizes.mobileDevice
                                            ? '10px 0 0 0'
                                            : '-33px 15px 0 0'
                                    }
                                    fontSize={'14px'}
                                    helperText={`${
                                        charCountLimit -
                                            unidSurgeryInfo.reasonText?.length <
                                        0
                                            ? 0
                                            : charCountLimit -
                                              unidSurgeryInfo.reasonText?.length
                                    } ${t(
                                        'consignmentBilling.priceOverride.charactersRemainingLabel'
                                    )}`}
                                    justifyContent={'flex-end'}
                                    boxShadow={'none'}
                                    contentBodyMargin={'10px 0px 0px 3px'}
                                    cardHeaderMargin={'14px 0px 0px 0px'}
                                    cardFooterMargin={'2px 0px 24px 23px'}
                                    // maxLength={textAreaCharLimit}
                                    autoResize={false}
                                    isScrollBar={true}
                                    isTextAreaResize={false}
                                    textAreaBorderRadius={'6px'}
                                    placeholderFont={'11px'}
                                    placeholderHeight={'100px'}
                                    row={3}
                                />
                            )}
                        </div>
                    </InfoMainContainer>
                )}

                {/* mpxr confirmation card */}
                {showConfirmationCheckbox && (
                    <MpxrConfirmationCard
                        isConfirmationCheckboxChecked={
                            isConfirmationCheckboxChecked
                        }
                        setIsConfirmationCheckboxChecked={
                            setIsConfirmationCheckboxChecked
                        }
                    />
                )}
            </Box>
        </ParentDiv>
    );
};

export default UnidSurgeryInfo;
